/**
 * Hardcoded list of email addresses that are allowed to access the panchang content.
 * Add or remove emails here. Comparison is case-insensitive.
 */
const ALLOWED_EMAILS = [
  "gauthamsaiju1@gmail.com",
  "gauthamsaiju@hotmail.com",
  "ekdhilipkumar@gmail.com",
  "astrodiaries@gmail.com",
  "astroreport2030@gmail.com",
  // Add more emails as needed:
  // "gautham@example.com",
];

export const isEmailAllowed = (email) => {
  if (!email || typeof email !== "string") return false;
  const normalized = email.trim().toLowerCase();
  return ALLOWED_EMAILS.some((allowed) => allowed.toLowerCase() === normalized);
};

export default ALLOWED_EMAILS;
